export function PageHeader({ title, subtitle, action, testid }) {
  return (
    <div data-testid={testid} className="flex items-end justify-between gap-4 mb-7 pb-5 border-b border-[#E2E0D8]">
      <div>
        <p className="text-xs uppercase tracking-[0.22em] text-[#8A9A92] mb-2">Floristería · ERP</p>
        <h1 className="font-heading text-3xl md:text-4xl font-black tracking-tight text-[#2A3F35]">{title}</h1>
        {subtitle && <p className="text-[#5C6B64] mt-2 max-w-2xl">{subtitle}</p>}
      </div>
      {action && <div>{action}</div>}
    </div>
  );
}

export function StatusChip({ status }) {
  const map = {
    borrador: { cls: "chip-muted", label: "Borrador" },
    firmada: { cls: "chip-info", label: "Firmada" },
    enviada: { cls: "chip-info", label: "Enviada" },
    autorizada: { cls: "chip-success", label: "Autorizada" },
    rechazada: { cls: "chip-danger", label: "Rechazada" },
    no_autorizada: { cls: "chip-danger", label: "No autorizada" },
    anulada: { cls: "chip-muted", label: "Anulada" },
    entrada: { cls: "chip-success", label: "Entrada" },
    salida: { cls: "chip-warning", label: "Salida" },
    ajuste: { cls: "chip-info", label: "Ajuste" },
  };
  const m = map[status] || { cls: "chip-muted", label: status || "—" };
  return <span className={`status-chip ${m.cls}`}>{m.label}</span>;
}

export function EmptyState({ title, hint, testid }) {
  return (
    <div data-testid={testid} className="card-soft p-10 text-center">
      <p className="font-heading text-lg font-bold text-[#2A3F35]">{title}</p>
      {hint && <p className="text-sm text-[#5C6B64] mt-1">{hint}</p>}
    </div>
  );
}
